import { Prompt } from 'react-router-dom';

import Button from '~/components/Button';

import styles from './FormSaveButton.style';

class FormSaveButton extends React.Component {
  blockNavigation = (isDirty, location) => {
    return (
      isDirty === true &&
      !/\/forms\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?(|\/preview)$/.test(
        location.pathname,
      )
    );
  };

  render() {
    const { classes, isDirty, onSave } = this.props;

    return isDirty === true ? (
      <div className={classes.saveActions}>
        <div className={classes.saveContent}>
          <p className={classes.saveDescription}>
            {'Hit save to update your form.'}
          </p>
          <Button
            variant="primary"
            className={classes.saveButton}
            onClick={onSave}>
            <span>Save Changes</span>
          </Button>

          <Prompt
            when={isDirty}
            message="You have unsaved changes. Are you sure you want to leave?"
          />
        </div>
      </div>
    ) : null;
  }
}

FormSaveButton.propTypes = {
  onSave: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
};

export default withStyles(styles)(FormSaveButton);
